import React, { useEffect, useState } from "react";
import { Button } from "@lightspeed/flame/Button";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { autoLogin } from "../../redux/actions/userActions";
import "../../css/login.css";

const AutoLogin = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const [message, setMessage] = useState("Signing you in...");
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");

    if (!token) {
      setFailed(true);
      setMessage("Auto-login token is missing.");
      return;
    }

    dispatch(autoLogin({ token }))
      .then(() => {
        history.replace("/");
      })
      .catch((err) => {
        console.log(err);
        setFailed(true);
        setMessage("Auto-login link is invalid or expired.");
      });
  }, [dispatch, history, location.search]);

  return (
    <div className="login-page-wrapper">
      <div className="login-container auto-login-container">
        <div className="login-header">
          <h2>Auto Login</h2>
          <p>{message}</p>
        </div>

        {failed && (
          <Button
            className="login-button"
            block={false}
            type="button"
            fill={true}
            variant="primary"
            onClick={() => history.replace("/login")}
          >
            Back to login
          </Button>
        )}
      </div>
    </div>
  );
};

export default AutoLogin;
